import { useCallback, useEffect } from 'react';
export const useKeybind = ({ onOpenAccountDialog }) => {
    const keyupHandler = useCallback((e) => {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLTextAreaElement)
            return;
        if (e.shiftKey)
            return;
        if (e.code === 'KeyA') {
            onOpenAccountDialog();
        }
    }, []);
    useEffect(() => {
        document.addEventListener('keyup', keyupHandler);
        return () => {
            document.removeEventListener('keyup', keyupHandler);
        };
    }, []);
};
